document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('form[action*="/cart/add"]').forEach(form=>{form.addEventListener('submit',()=>{const b=form.querySelector('button[type="submit"]');if(b){b.textContent='Ajout en cours…';b.disabled=true}})})});


document.addEventListener('DOMContentLoaded', function () {
  var options = document.querySelectorAll('.bundle-option');
  var quantity = document.getElementById('bundle-quantity');
  if (!options.length || !quantity) return;

  options.forEach(function (option) {
    option.addEventListener('click', function () {
      options.forEach(function (item) { item.classList.remove('is-selected'); });
      option.classList.add('is-selected');
      var radio = option.querySelector('input[type="radio"]');
      if (radio) {
        radio.checked = true;
        quantity.value = radio.value;
      }
    });
  });
});

// Compte à rebours à date fixe : il ne redémarre pas à chaque visite.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-countdown]').forEach(function (banner) {
    var endValue = banner.getAttribute('data-countdown-end');
    var endTime = Date.parse(endValue || '');
    if (!Number.isFinite(endTime)) return;

    var days = banner.querySelector('[data-days]');
    var hours = banner.querySelector('[data-hours]');
    var minutes = banner.querySelector('[data-minutes]');
    var seconds = banner.querySelector('[data-seconds]');
    var label = banner.querySelector('.launch-promo__message span');

    function pad(value) { return String(value).padStart(2, '0'); }
    function updateCountdown() {
      var remaining = endTime - Date.now();
      if (remaining <= 0) {
        banner.classList.add('is-expired');
        if (label) label.textContent = 'Offre terminée';
        return false;
      }
      var totalSeconds = Math.floor(remaining / 1000);
      if (days) days.textContent = pad(Math.floor(totalSeconds / 86400));
      if (hours) hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
      if (minutes) minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      if (seconds) seconds.textContent = pad(totalSeconds % 60);
      return true;
    }

    if (updateCountdown()) {
      var timer = window.setInterval(function () {
        if (!updateCountdown()) window.clearInterval(timer);
      }, 1000);
    }
  });

  document.querySelectorAll('[data-copy-code]').forEach(function (button) {
    button.addEventListener('click', function () {
      var code = button.getAttribute('data-copy-code');
      if (!code || !navigator.clipboard) return;
      navigator.clipboard.writeText(code).then(function () {
        var original = button.innerHTML;
        button.textContent = 'Code copié ✓';
        window.setTimeout(function () { button.innerHTML = original; }, 1600);
      });
    });
  });
});
